import { render, staticRenderFns } from "./errorPrompt.vue?vue&type=template&id=57c2e5de&scoped=true&"
import script from "./errorPrompt.vue?vue&type=script&lang=js&"
export * from "./errorPrompt.vue?vue&type=script&lang=js&"
import style0 from "./errorPrompt.vue?vue&type=style&index=0&id=57c2e5de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2e5de",
  null
  
)

export default component.exports